import React from 'react';
import styled from 'styled-components';

import { DefaultWidgetBorder } from '../../../../styles/BordersStyle';
import ColorConstants from '../../../../../constants/ColorConstants';
import { Title } from '../../../../base/Text';
import { getZIndexByLayerName, LayerNames } from '../../../../../constants/layers.constants';
import { FlexDiv } from '../../../../base/Div';
import { MobileScreen } from '../../../../styles/ConstantMediaQuery';
import TEST_ID from '../../../../../constants/testId.constants';

const defaultProps = {
    children: null,
    styles: {},
    title: null,
};

const DropDown = ({
    children, title, styles,
}) => (
    <Container
        data-testid={TEST_ID.MULTI_SELECTOR.DROP_DOWN}
        styles={styles.wrapper}
    >
        <StyledTitle styles={styles.title}>{title}</StyledTitle>
        <Wrapper>
            {children}
        </Wrapper>
    </Container>
);

const Container = styled(FlexDiv)`
    ${DefaultWidgetBorder};
    background-color: ${ColorConstants['catskill-white']};
    flex-direction: column;
    height: auto;
    margin-top: 20px;
    position: absolute;
    width: ${({ width = '320px' }) => width}; 
    z-index: ${getZIndexByLayerName(LayerNames.CURR_VALUE_10)};
    right: 0px;

    ${({ styles }) => styles && { ...styles }};
    
    @media ${MobileScreen} {
        width: 100%;
    }
`;

const Wrapper = styled.div`
    ${DefaultWidgetBorder};
    background-color: ${ColorConstants.white};
    border-width: 1px 0px 0px 0px;
    height: auto;
    padding-top: 18px;
`;

const StyledTitle = styled(Title)`
    font-size: 15px;
    height: 40px;
    line-height: 40px;
    padding: 0px 10px;
     ${({ styles }) => styles && { ...styles }};
`;


DropDown.defaultProps = defaultProps;

export default DropDown;
